const getStartMarkForMeasure = (
  startMark: PerformanceMark | undefined,
  baselineMark: PerformanceMark | undefined,
): PerformanceMark | undefined => {
  // If there's no baseline, return the startMark or undefined (0 mark)
  if (baselineMark === undefined) {
    return startMark;
  }

  // If there's no startMark, return the baseline
  if (startMark === undefined) {
    return baselineMark;
  }

  // Check whichever happened later, and use that for comparison
  return startMark.startTime < baselineMark.startTime ? baselineMark : startMark;
};

export default getStartMarkForMeasure;
